// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"527":"9f47d3eb","686":"9f47d3eb","794":"9f47d3eb"}[chunkId] + ".css";
};